import './loadingshadow.scss';
import { FunctionComponent } from "react";

const LoadingShadow : FunctionComponent = () => {
    return (
        <div className="lopading-shadow">
            <div className="blur"></div>
            <div className="loader"></div>
        </div>
    )
}

export default LoadingShadow;